import { makeStyles, Theme } from "@material-ui/core";
import {
  h4Medium,
  h5Medium,
  h6Regular,
  h6Medium,
  h7Regular,
} from "../../shared/typography";
import { pointer, withOpacity } from "../../shared/mixins";

export interface OrdersHistoryStyleProps {
  dir: "rtl" | "ltr";
}

export const useStyles = makeStyles<Theme, OrdersHistoryStyleProps>(
  (theme) => ({
    ordersHistoryContainer: {
      display: "flex",
      flexDirection: "column",
      minHeight: "70vh",
      height: "100%",
    },
    tableLoader: {
      minHeight: "30vh",
      height: "100%",
    },
    ordersHistoryTitle: {
      marginBottom: 40,
      "@media (max-width:940px)": {
        marginBottom: 16,
        fontSize: 29,
      },
    },
    orderHistoryHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    ordersHistoryContent: {
      display: "flex",
      flexDirection: "column",
      gap: 40,
      padding: 40,
      background: "#FFFFFF",
      borderRadius: 16,
      height: "100%",
    },
    ordersHistoryEmptyList: {
      ...h4Medium,
      ...withOpacity(0.74),
      textAlign: "center",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 48,
      justifyContent: "center",
      alignItems: "center",
    },
    ordersHistoryHeaderTitles: {
      ...h4Medium,
      ...withOpacity(0.8),
      ...pointer,
    },
    /** TABLE **/
    ordersHistoryTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: 24,
    },

    /** THEAD **/
    ordersHistoryTableHead: {
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
    },

    /** HEADER ROW **/
    ordersHistoryHeaderRow: {
      height: 48,
    },

    /** HEADER CELL **/
    ordersHistoryTableHeaders: (props) => ({
      ...h6Regular,
      ...withOpacity(0.4),
      textAlign: props.dir === "rtl" ? "right" : "left",
      padding: "0 0 16px 0",
    }),

    /** BODY ROW **/
    ordersHistoryRow: {
      height: 72,
    },

    /** CELLS **/
    cellNumber: {
      ...h6Regular,
      ...withOpacity(0.64),
      width: "15%",
      verticalAlign: "middle",
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
      padding: 0,
    },
    cellAmount: {
      ...h6Medium,
      width: "15%",
      verticalAlign: "middle",
      ...withOpacity(0.8),
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
      padding: "0 8px",
    },
    cellAmountWithSubOrders: {
      ...h7Regular,
      ...withOpacity(0.4),
    },
    cellDelivery: {
      ...h6Medium,
      width: "35%",
      verticalAlign: "middle",
      ...withOpacity(0.8),
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
      padding: "0 8px",
    },
    deliveryDateDiv: {
      height: 72,
      display: "flex",
      alignItems: "center",
    },
    deliveryDateDivWithBorderBottom: {
      height: 72,
      display: "flex",
      alignItems: "center",
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
    },
    deliveryDateFormattedDate: {
      flex: 5,
    },
    deliveryDateTimewindow: {
      flex: 3,
      ...h6Regular,
      ...withOpacity(0.4),
    },
    deliveryCanceledMsg: {
      ...h6Regular,
      ...withOpacity(0.4),
      height: 72,
      display: "flex",
      alignItems: "center",
    },
    deliveryWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    cellStatus: {
      width: "25%",
      verticalAlign: "middle",
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
      padding: 0,
    },
    statusDiv: {
      height: 72,
      display: "flex",
      alignItems: "center",
    },
    statusDivWithBorderBottom: {
      height: 72,
      display: "flex",
      alignItems: "center",
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
    },
    cellDetails: (props) => ({
      ...h6Medium,
      color: "#80BB34",
      ...pointer,
      width: "10%",
      textAlign: props.dir === "rtl" ? "left" : "right",
      verticalAlign: "middle",
      borderBottom: "1px dashed rgba(21, 34, 47, 0.18)",
      padding: 0,
    }),
    loadMoreBtn: {
      height: 54,
      width: 260,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#FFF",
      color: "#80BB34",
      border: "none",
      justifySelf: "center",
      ...pointer,
      ...h5Medium,
    },
  })
);
